//our root app component
import { Component, ViewEncapsulation } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
/**
 * dialog for pilotpay
 */
@Component({
	selector: 'app-pilotpay-icondialog',
	styleUrls: ['./icondialog.component.scss'],
	templateUrl: './icondialog.component.html',
	encapsulation: ViewEncapsulation.None
})
export class IconDialogComponent {
	constructor(dialogRef: MatDialogRef<IconDialogComponent>) {
		this.dialogRef = dialogRef;
	}

	public icons: string[] = [
		// tslint:disable-next-line:max-line-length
		'fa-address-book',
		'fa-address-book-o',
		'fa-address-card',
		'fa-address-card-o',
		'fa-adjust',
		'fa-american-sign-language-interpreting',
		'fa-anchor',
		'fa-archive',
		'fa-area-chart',
		'fa-arrows',
		'fa-arrows-h',
		'fa-arrows-v',
		'fa-asl-interpreting',
		'fa-assistive-listening-systems',
		'fa-asterisk',
		'fa-at',
		'fa-audio-description',
		'fa-automobile',
		'fa-balance-scale',
		'fa-ban',
		'fa-bank',
		'fa-bar-chart',
		'fa-bar-chart-o',
		'fa-barcode',
		'fa-bars',
		'fa-bath',
		'fa-bathtub',
		'fa-battery',
		'fa-battery-0',
		'fa-battery-1',
		'fa-battery-2',
		'fa-battery-3',
		'fa-battery-4',
		'fa-battery-empty',
		'fa-battery-full',
		'fa-battery-half',
		'fa-battery-quarter',
		'fa-battery-three-quarters',
		'fa-bed',
		'fa-beer',
		'fa-bell',
		'fa-bell-o',
		'fa-bell-slash',
		'fa-bell-slash-o',
		'fa-bicycle',
		'fa-binoculars',
		'fa-birthday-cake',
		'fa-blind',
		'fa-bluetooth',
		'fa-bluetooth-b',
		'fa-bolt',
		'fa-bomb',
		'fa-book',
		'fa-bookmark',
		'fa-bookmark-o',
		'fa-braille',
		'fa-briefcase',
		'fa-bug',
		'fa-building',
		'fa-building-o',
		'fa-bullhorn',
		'fa-bullseye',
		'fa-bus',
		'fa-cab',
		'fa-calculator',
		'fa-calendar',
		'fa-calendar-check-o',
		'fa-calendar-minus-o',
		'fa-calendar-o',
		'fa-calendar-plus-o',
		'fa-calendar-times-o',
		'fa-camera',
		'fa-camera-retro',
		'fa-car',
		'fa-caret-square-o-down',
		'fa-caret-square-o-left',
		'fa-caret-square-o-right',
		'fa-caret-square-o-up',
		'fa-cart-arrow-down',
		'fa-cart-plus',
		'fa-cc',
		'fa-certificate',
		'fa-check',
		'fa-check-circle',
		'fa-check-circle-o',
		'fa-check-square',
		'fa-check-square-o',
		'fa-child',
		'fa-circle',
		'fa-circle-o',
		'fa-circle-o-notch',
		'fa-circle-thin',
		'fa-clock-o',
		'fa-clone',
		'fa-close',
		'fa-cloud',
		'fa-cloud-download',
		'fa-cloud-upload',
		'fa-code',
		'fa-code-fork',
		'fa-coffee',
		'fa-cog',
		'fa-cogs',
		'fa-comment',
		'fa-comment-o',
		'fa-commenting',
		'fa-commenting-o',
		'fa-comments',
		'fa-comments-o',
		'fa-compass',
		'fa-copyright',
		'fa-creative-commons',
		'fa-credit-card',
		'fa-credit-card-alt',
		'fa-crop',
		'fa-crosshairs',
		'fa-cube',
		'fa-cubes',
		'fa-cutlery',
		'fa-dashboard',
		'fa-database',
		'fa-deaf',
		'fa-deafness',
		'fa-desktop',
		'fa-diamond',
		'fa-dot-circle-o',
		'fa-download',
		'fa-drivers-license',
		'fa-drivers-license-o',
		'fa-edit',
		'fa-ellipsis-h',
		'fa-ellipsis-v',
		'fa-envelope',
		'fa-envelope-o',
		'fa-envelope-open',
		'fa-envelope-open-o',
		'fa-envelope-square',
		'fa-eraser',
		'fa-exchange',
		'fa-exclamation',
		'fa-exclamation-circle',
		'fa-exclamation-triangle',
		'fa-external-link',
		'fa-external-link-square',
		'fa-eye',
		'fa-eye-slash',
		'fa-eyedropper',
		'fa-fax',
		'fa-feed',
		'fa-female',
		'fa-fighter-jet',
		'fa-file-archive-o',
		'fa-file-audio-o',
		'fa-file-code-o',
		'fa-file-excel-o',
		'fa-file-image-o',
		'fa-file-movie-o',
		'fa-file-pdf-o',
		'fa-file-photo-o',
		'fa-file-picture-o',
		'fa-file-powerpoint-o',
		'fa-file-sound-o',
		'fa-file-video-o',
		'fa-file-word-o',
		'fa-file-zip-o',
		'fa-film',
		'fa-filter',
		'fa-fire',
		'fa-fire-extinguisher',
		'fa-flag',
		'fa-flag-checkered',
		'fa-flag-o',
		'fa-flash',
		'fa-flask',
		'fa-folder',
		'fa-folder-o',
		'fa-folder-open',
		'fa-folder-open-o',
		'fa-frown-o',
		'fa-futbol-o',
		'fa-gamepad',
		'fa-gavel',
		'fa-gear',
		'fa-gears',
		'fa-gift',
		'fa-glass',
		'fa-globe',
		'fa-graduation-cap',
		'fa-group',
		'fa-hand-grab-o',
		'fa-hand-lizard-o',
		'fa-hand-paper-o',
		'fa-hand-peace-o',
		'fa-hand-pointer-o',
		'fa-hand-rock-o',
		'fa-hand-scissors-o',
		'fa-hand-spock-o',
		'fa-hand-stop-o',
		'fa-handshake-o',
		'fa-hard-of-hearing',
		'fa-hashtag',
		'fa-hdd-o',
		'fa-headphones',
		'fa-heart',
		'fa-heart-o',
		'fa-heartbeat',
		'fa-history',
		'fa-home',
		'fa-hotel',
		'fa-hourglass',
		'fa-hourglass-1',
		'fa-hourglass-2',
		'fa-hourglass-3',
		'fa-hourglass-end',
		'fa-hourglass-half',
		'fa-hourglass-o',
		'fa-hourglass-start',
		'fa-i-cursor',
		'fa-id-badge',
		'fa-id-card',
		'fa-id-card-o',
		'fa-image',
		'fa-inbox',
		'fa-industry',
		'fa-info',
		'fa-info-circle',
		'fa-institution',
		'fa-key',
		'fa-keyboard-o',
		'fa-language',
		'fa-laptop',
		'fa-leaf',
		'fa-legal',
		'fa-lemon-o',
		'fa-level-down',
		'fa-level-up',
		'fa-life-bouy',
		'fa-life-buoy',
		'fa-life-ring',
		'fa-life-saver',
		'fa-lightbulb-o',
		'fa-line-chart',
		'fa-location-arrow',
		'fa-lock',
		'fa-low-vision',
		'fa-magic',
		'fa-magnet',
		'fa-mail-forward',
		'fa-mail-reply',
		'fa-mail-reply-all',
		'fa-male',
		'fa-map',
		'fa-map-marker',
		'fa-map-o',
		'fa-map-pin',
		'fa-map-signs',
		'fa-meh-o',
		'fa-microchip',
		'fa-microphone',
		'fa-microphone-slash',
		'fa-minus',
		'fa-minus-circle',
		'fa-minus-square',
		'fa-minus-square-o',
		'fa-mobile',
		'fa-mobile-phone',
		'fa-money',
		'fa-moon-o',
		'fa-mortar-board',
		'fa-motorcycle',
		'fa-mouse-pointer',
		'fa-music',
		'fa-navicon',
		'fa-newspaper-o',
		'fa-object-group',
		'fa-object-ungroup',
		'fa-paint-brush',
		'fa-paper-plane',
		'fa-paper-plane-o',
		'fa-paw',
		'fa-pencil',
		'fa-pencil-square',
		'fa-pencil-square-o',
		'fa-percent',
		'fa-phone',
		'fa-phone-square',
		'fa-photo',
		'fa-picture-o',
		'fa-pie-chart',
		'fa-plane',
		'fa-plug',
		'fa-plus',
		'fa-plus-circle',
		'fa-plus-square',
		'fa-plus-square-o',
		'fa-podcast',
		'fa-power-off',
		'fa-print',
		'fa-puzzle-piece',
		'fa-qrcode',
		'fa-question',
		'fa-question-circle',
		'fa-question-circle-o',
		'fa-quote-left',
		'fa-quote-right',
		'fa-random',
		'fa-recycle',
		'fa-refresh',
		'fa-registered',
		'fa-remove',
		'fa-reorder',
		'fa-reply',
		'fa-reply-all',
		'fa-retweet',
		'fa-road',
		'fa-rocket',
		'fa-rss',
		'fa-rss-square',
		'fa-s15',
		'fa-search',
		'fa-search-minus',
		'fa-search-plus',
		'fa-send',
		'fa-send-o',
		'fa-server',
		'fa-share',
		'fa-share-alt',
		'fa-share-alt-square',
		'fa-share-square',
		'fa-share-square-o',
		'fa-shield',
		'fa-ship',
		'fa-shopping-bag',
		'fa-shopping-basket',
		'fa-shopping-cart',
		'fa-shower',
		'fa-sign-in',
		'fa-sign-language',
		'fa-sign-out',
		'fa-signal',
		'fa-signing',
		'fa-sitemap',
		'fa-sliders',
		'fa-smile-o',
		'fa-snowflake-o',
		'fa-soccer-ball-o',
		'fa-sort',
		'fa-sort-alpha-asc',
		'fa-sort-alpha-desc',
		'fa-sort-amount-asc',
		'fa-sort-amount-desc',
		'fa-sort-asc',
		'fa-sort-desc',
		'fa-sort-down',
		'fa-sort-numeric-asc',
		'fa-sort-numeric-desc',
		'fa-sort-up',
		'fa-space-shuttle',
		'fa-spinner',
		'fa-spoon',
		'fa-square',
		'fa-square-o',
		'fa-star',
		'fa-star-half',
		'fa-star-half-empty',
		'fa-star-half-full',
		'fa-star-half-o',
		'fa-star-o',
		'fa-sticky-note',
		'fa-sticky-note-o',
		'fa-street-view',
		'fa-suitcase',
		'fa-sun-o',
		'fa-support',
		'fa-tablet',
		'fa-tachometer',
		'fa-tag',
		'fa-tags',
		'fa-tasks',
		'fa-taxi',
		'fa-television',
		'fa-terminal',
		'fa-thermometer',
		'fa-thermometer-0',
		'fa-thermometer-1',
		'fa-thermometer-2',
		'fa-thermometer-3',
		'fa-thermometer-4',
		'fa-thermometer-empty',
		'fa-thermometer-full',
		'fa-thermometer-half',
		'fa-thermometer-quarter',
		'fa-thermometer-three-quarters',
		'fa-thumb-tack',
		'fa-thumbs-down',
		'fa-thumbs-o-down',
		'fa-thumbs-o-up',
		'fa-thumbs-up',
		'fa-ticket',
		'fa-times',
		'fa-times-circle',
		'fa-times-circle-o',
		'fa-times-rectangle',
		'fa-times-rectangle-o',
		'fa-tint',
		'fa-toggle-down',
		'fa-toggle-left',
		'fa-toggle-off',
		'fa-toggle-on',
		'fa-toggle-right',
		'fa-toggle-up',
		'fa-trademark',
		'fa-trash',
		'fa-trash-o',
		'fa-tree',
		'fa-trophy',
		'fa-truck',
		'fa-tty',
		'fa-tv',
		'fa-umbrella',
		'fa-universal-access',
		'fa-university',
		'fa-unlock',
		'fa-unlock-alt',
		'fa-unsorted',
		'fa-upload',
		'fa-user',
		'fa-user-circle',
		'fa-user-circle-o',
		'fa-user-o',
		'fa-user-plus',
		'fa-user-secret',
		'fa-user-times',
		'fa-users',
		'fa-vcard',
		'fa-vcard-o',
		'fa-video-camera',
		'fa-volume-control-phone',
		'fa-volume-down',
		'fa-volume-off',
		'fa-volume-up',
		'fa-warning',
		'fa-wheelchair',
		'fa-wheelchair-alt',
		'fa-wifi',
		'fa-window-close',
		'fa-window-close-o',
		'fa-window-maximize',
		'fa-window-minimize',
		'fa-window-restore'
	];
	public selectedIcon: string = 'fa-address-book';
	public dialogRef: MatDialogRef<IconDialogComponent>;

	public okay(icon: string = 'fa-address-book'): void {
		this.selectedIcon = icon;
		this.dialogRef.close(icon);
	}

	public close(): void {
		this.dialogRef.close();
	}
}
